import segment from '@segment/snippet';
import { env } from '@/config';

export function injectTracking() {
  const jsSnippet = segment.min({
    host: env.VUE_APP_SEGMENT_HOST,
    apiKey: env.VUE_APP_SEGMENT_API_KEY,
  });

  // loadAJS
  const script = document.createElement('script');
  script.innerHTML = jsSnippet;

  document.head.appendChild(script);
}

export function sendTrackingPageView(path) {
  if (!window.analytics) {
    return;
  }
  window.analytics.page({
    url: path,
  });
}

export function sendTrackingEvent(eventName, eventValue = {}) {
  if (!window.analytics) {
    return;
  }
  window.analytics.track(eventName, eventValue);
}

export function identifyTracking(identifyProps = {}) {
  window.analytics?.identify(identifyProps);
}

export function sendTrackingIdentity({ fingerprint, accountID }, traits = {}) {
  if (!window.analytics) {
    return;
  }

  const identity = fingerprint || accountID;

  if (identity) {
    window.analytics.identify(
      identity,
      traits,
    );
  } else {
    window.analytics.identify(
      traits,
    );
  }
}

